import React, { useState, useEffect } from 'react'
import ImagesPallet from '../../../../utils/ImagesPallet'
import ColorPallete from '../../../../utils/ColorPallet'

 function RunningSection() {
  const [position, setPosition] = useState(-100);

  useEffect(() => {
     const interval = setInterval(() => {
       setPosition(prev => {
         if (prev > 100) return -100;
         return prev + 0.3; 
       });
     }, 10);

     return () => clearInterval(interval);
   }, []);

   return (
     <div className="w-full h-36 overflow-hidden backdrop-blur-sm p-4  mt-16 flex justify-center items-center" style={{ backgroundColor: ColorPallete.primaryDarkBrown }}>
      <div 
        className="text-white text-xl font-medium"
        style={{ 
          transform: `translateX(${position}%)`,
          whiteSpace: 'nowrap'
        }}
      >
         <div className='flex flex-row gap-20 pointer-events-auto justify-center items-center'>
        
            {/* Periton Solar */}  
            <img className='w-auto h-32'
              src={ImagesPallet.PeritonSolar}/>
          
            {/* Pudu Robotics */}
            <img className='w-auto h-20'
              src={ImagesPallet.PuduRobotics}/>
          
           {/* Loreal */}
            <img className='w-64 h-20'
             src={ImagesPallet.BarberLoreal} />
           
           {/* Zycoo */}
           <img className='w-64'
             src={ImagesPallet.Zycoo} />
           
           {/* Videray */}
           <img className='w-80 h-30'
             src={ImagesPallet.Videray} />
          
            
        </div>
      </div>
    </div>
   )
 }

 export default RunningSection
